export default "__VITE_ASSET__DhIuY8Jw__"